var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { staticClass: "bg-white", attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-user" }
          }),
          _vm._v(" " + _vm._s(_vm.$t(_vm.page_title)) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-xs" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("personal_data")))
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "q-field",
              {
                attrs: {
                  error: _vm.register_error,
                  "error-label": _vm.register_error
                    ? _vm.register_error_message
                      ? _vm.$t(_vm.register_error_message)
                      : _vm.custom_error_message
                    : ""
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("register"),
                    error: _vm.$v.register.$error
                  },
                  on: {
                    input: _vm.$v.register.$touch,
                    blur: function($event) {
                      return _vm.registerUnique()
                    }
                  },
                  model: {
                    value: _vm.register,
                    callback: function($$v) {
                      _vm.register = $$v
                    },
                    expression: "register"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("name"), disable: "" },
              model: {
                value: _vm.full_name,
                callback: function($$v) {
                  _vm.full_name = $$v
                },
                expression: "full_name"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c(
              "q-field",
              { attrs: { error: _vm.email_error } },
              [
                _vm.email_error
                  ? _c(
                      "span",
                      { attrs: { slot: "error-label" }, slot: "error-label" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$t("email_already_in_use_click")) +
                            "\n\t\t\t\t\t"
                        ),
                        _c(
                          "router-link",
                          { attrs: { to: "recover-password" } },
                          [_vm._v(_vm._s(_vm.$t("here")))]
                        ),
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$t("to_recover_your_password")) +
                            "\n\t\t\t\t"
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c("q-input", {
                  attrs: {
                    type: "email",
                    "float-label": _vm.$t("email"),
                    error: _vm.$v.email.$error
                  },
                  on: { input: _vm.$v.email.$touch },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              attrs: {
                type: "email",
                "float-label": _vm.$t("email_confirm"),
                error: _vm.$v.email_confirm.$error
              },
              on: { input: _vm.$v.email_confirm.$touch },
              model: {
                value: _vm.email_confirm,
                callback: function($$v) {
                  _vm.email_confirm = $$v
                },
                expression: "email_confirm"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c(
              "q-field",
              {
                attrs: {
                  helper: _vm.$t(_vm.getPasswordHelper),
                  error: _vm.$v.password.$error
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("password"),
                    type: "password",
                    error: _vm.$v.password.$error
                  },
                  on: { input: _vm.$v.password.$touch },
                  model: {
                    value: _vm.password,
                    callback: function($$v) {
                      _vm.password = $$v
                    },
                    expression: "password"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              attrs: {
                type: "password",
                "float-label": _vm.$t("confirm_password")
              },
              model: {
                value: _vm.password_confirm,
                callback: function($$v) {
                  _vm.password_confirm = $$v
                },
                expression: "password_confirm"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "login" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-dialog",
        {
          attrs: { cancel: false },
          on: {
            ok: function($event) {
              _vm.show_error = false
            }
          },
          model: {
            value: _vm.show_error,
            callback: function($$v) {
              _vm.show_error = $$v
            },
            expression: "show_error"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("register_error")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("user_doesnt_have_access")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }